import React, { useState } from 'react';
import PropTypes from 'prop-types';

import OrganizationFieldsModal from 'react/containers/modals/Saml/OrganizationFieldsModal';
import LocaleKeyFieldsModal from 'react/containers/modals/Saml/LocaleKeyFieldsModal';
import GroupsFieldsModal from 'react/containers/modals/Saml/GroupsFieldsModal';
import UserTagFieldsModal from 'react/containers/modals/Saml/UserTagFieldsModal';

import MultipleField from 'react/components/SamlConfiguration/MultipleField';
import GmInfoTooltip from 'react/components/Tooltip';

import { TextField, LookupField, SelectField } from 'react/components/fields';
import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { getResourceTo } from 'react/utils/utils';

function OrganizationDefaultValueField() {
  return (
    <>
      <div className="forkArrow" />
      <LookupField
        label="samlConfiguration.defaultValue"
        name="idp.fieldMappings.userOrganizationKey.defaultValue"
        lookupEntity="Organization"
        lookupEntityColumn="description"
        required
      />
    </>
  );
}

function renderOrganizationModalButton(openOrganizationFieldsModalAction) {
  const openOrgModal = () => {
    openOrganizationFieldsModalAction();
  };

  return (
    <input
      type="button"
      value="MANAGE MAPPINGS"
      className="btn-secondary"
      onClick={openOrgModal}
    />
  );
}

function LocaleKeyDefaultValueFields() {
  return (
    <>
      <div className="forkArrow" />
      <LookupField
        label="samlConfiguration.defaultValue"
        name="idp.fieldMappings.userI18nLocaleKey.defaultValue"
        lookupEntity="I18NLocale"
        lookupEntityColumn="description"
        required
      />
    </>
  );
}

function renderLocaleKeyModalButton(openLocaleKeyFieldsModalAction) {
  const openLocaleKeyModal = () => {
    openLocaleKeyFieldsModalAction();
  };

  return (
    <input
      type="button"
      value="MANAGE MAPPINGS"
      className="btn-secondary"
      onClick={openLocaleKeyModal}
    />
  );
}

function GroupKeyDefaultValueFields() {
  return (
    <>
      <div className="forkArrow" />
      <LookupField
        label="samlConfiguration.defaultValue"
        name="idp.fieldMappings.userGroups.defaultValue"
        lookupEntity="Group"
        lookupEntityColumn="name"
        required
      />
    </>
  );
}

function renderGroupModalButton(openGroupsFieldsModalAction) {
  const openGroupsModal = () => {
    openGroupsFieldsModalAction();
  };

  return (
    <input
      type="button"
      value="MANAGE MAPPINGS"
      className="btn-secondary"
      onClick={openGroupsModal}
    />
  );
}

function renderUserTagModalButton(openUserTagFieldsModalAction) {
  const openUserTagModal = () => {
    openUserTagFieldsModalAction();
  };

  return (
    <input
      type="button"
      value="MANAGE MAPPINGS"
      className="btn-secondary"
      onClick={openUserTagModal}
    />
  );
}

function defaultValuesTooltip() {
  const [display, setDisplay] = useState('none');
  const label = getResourceTo('samlConfiguration.label.defaultValues');
  const defaultValuesInfo = getResourceTo('samlConfiguration.label.DefaultValuesInfo');

  const showTooltip = () => {
    setDisplay('block');
  };

  const hideTooltip = () => {
    setDisplay('none');
  };

  return (
    <div className="defaultValuesInfo">
      <p>{`${label}*`}</p>
      <div className="btn" onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
        <div className="defaulValuesTooltip" style={{ display }}>
          {defaultValuesInfo}
        </div>
      </div>
    </div>
  );
}

function FieldMapping(props) {
  const {
    idpName = '',
    organizationModalIsOpen,
    localeKeyModalIsOpen,
    groupsModalIsOpen,
    userTagModalIsOpen,
    toggleOrganizationFieldsModalAction,
    toggleLocaleKeyFieldsModalAction,
    toggleGroupsFieldsModalAction,
    toggleUserTagFieldsModalAction,
    openLocaleKeyFieldsModalAction,
    openOrganizationFieldsModalAction,
    openGroupsFieldsModalAction,
    openUserTagFieldsModalAction
  } = props;

  return (
    <FormSection
      title={getResourceTo(
        'samlConfiguration.fieldMappingSection.title',
        idpName
      )}
      subtitle="samlConfiguration.fieldMappingSection.subtitle"
      className="fieldMapping"
    >
      <OrganizationFieldsModal
        isOpen={organizationModalIsOpen}
        closeModalFn={toggleOrganizationFieldsModalAction}
      />
      <LocaleKeyFieldsModal
        isOpen={localeKeyModalIsOpen}
        closeModalFn={toggleLocaleKeyFieldsModalAction}
      />
      <GroupsFieldsModal
        isOpen={groupsModalIsOpen}
        closeModalFn={toggleGroupsFieldsModalAction}
      />
      <UserTagFieldsModal
        isOpen={userTagModalIsOpen}
        closeModalFn={toggleUserTagFieldsModalAction}
      />
      <FormSectionColumn>
        <div className="metadataLabels">
          <label>{getResourceTo('samlConfiguration.label.IdpAtribute')}</label>
          <label>{getResourceTo('samlConfiguration.label.GreenmileAtribute')}</label>
        </div>
        <MultipleField
          placeholder="userKey"
          tooltipResource="samlConfiguration.label.userKeyInfo"
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userKey.assertionFieldName"
            required
          />
        </MultipleField>
        <MultipleField
          placeholder="userName"
          tooltipResource="samlConfiguration.label.userNameInfo"
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userName.assertionFieldName"
            required
          />
        </MultipleField>
        <MultipleField
          placeholder="userEmail"
          tooltipResource="samlConfiguration.label.userEmailInfo"
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userEmail.assertionFieldName"
          />
        </MultipleField>
        <MultipleField
          placeholder="userLogin"
          tooltipResource="samlConfiguration.label.userLoginInfo"
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userLogin.assertionFieldName"
            required
          />
        </MultipleField>
        <MultipleField
          placeholder="User Additional Organizations"
          tooltipResource="samlConfiguration.label.userAdditionalOrganizationsInfo"
          openModalButton={defaultValuesTooltip}
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userOrganizations.assertionFieldName"
          />
        </MultipleField>
        <MultipleField
          placeholder="userOrganizationKey"
          tooltipResource="samlConfiguration.label.userOrganizationInfo"
          defaultValueField={OrganizationDefaultValueField}
          openModalButton={() => renderOrganizationModalButton(openOrganizationFieldsModalAction)}
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userOrganizationKey.assertionFieldName"
          />
        </MultipleField>
        <MultipleField
          placeholder="userI18nLocaleKey"
          tooltipResource="samlConfiguration.label.userLanguageInfo"
          defaultValueField={LocaleKeyDefaultValueFields}
          openModalButton={() => renderLocaleKeyModalButton(openLocaleKeyFieldsModalAction)}
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userI18nLocaleKey.assertionFieldName"
          />
        </MultipleField>
        <MultipleField
          placeholder="userGroups"
          tooltipResource="samlConfiguration.label.userGroupsInfo"
          defaultValueField={GroupKeyDefaultValueFields}
          openModalButton={() => renderGroupModalButton(openGroupsFieldsModalAction)}
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userGroups.assertionFieldName"
          />
        </MultipleField>
        <div className="multipleFieldWrapper">
          <div className="multipleField">
            <TextField
              label="samlConfiguration.assertionField"
              name="idp.fieldMappings.userUnitSystem.assertionFieldName"
            />
            <div className="arrowRight" />
            <div className="gmValuesInfo">
              <input
                type="text"
                placeholder="userUnitSystem"
                readOnly
                className="disabled"
              />
              <GmInfoTooltip resource="samlConfiguration.label.userUnitSystemInfo" />
            </div>
            <div className="forkArrow" />
            <SelectField
              label="samlConfiguration.defaultValue"
              name="idp.fieldMappings.userUnitSystem.defaultValue"
              options={[
                {
                  label: 'users.metric',
                  value: 'METRIC'
                },
                {
                  label: 'users.non_metric',
                  value: 'NON_METRIC'
                }
              ]}
            />
          </div>
        </div>
        <div className="multipleFieldWrapper">
          <div className="multipleField">
            <TextField
              label="samlConfiguration.assertionField"
              name="idp.fieldMappings.userDefaultEncoding.assertionFieldName"
            />
            <div className="arrowRight" />
            <div className="gmValuesInfo">
              <input
                type="text"
                placeholder="userDefaultEncoding"
                readOnly
                className="disabled"
              />
              <GmInfoTooltip resource="samlConfiguration.label.userDefaultEncodingInfo" />
            </div>
            <div className="forkArrow" />
            <SelectField
              placeholder={getResourceTo('samlConfiguration.label.selectPlaceholder')}
              label="samlConfiguration.defaultValue"
              name="idp.fieldMappings.userDefaultEncoding.defaultValue"
              options={[
                {
                  label: 'encodeType.utf8',
                  value: 'UTF_8'
                },
                {
                  label: 'encodeType.shiftJis',
                  value: 'SHIFT_JIS'
                },
                {
                  label: 'encodeType.eucJp',
                  value: 'EUC_JP'
                },
                {
                  label: 'encodeType.windows874',
                  value: 'WINDOWS_874'
                }
              ]}
            />
          </div>
        </div>
        <MultipleField
          placeholder="User Tags"
          tooltipResource="samlConfiguration.label.userTagsInfo"
          openModalButton={() => renderUserTagModalButton(openUserTagFieldsModalAction)}
        >
          <TextField
            label="samlConfiguration.assertionField"
            name="idp.fieldMappings.userAllowedTags.assertionFieldName"
          />
        </MultipleField>
      </FormSectionColumn>
    </FormSection>
  );
}

FieldMapping.propTypes = {
  idpName: PropTypes.string,
  organizationModalIsOpen: PropTypes.bool.isRequired,
  localeKeyModalIsOpen: PropTypes.bool.isRequired,
  groupsModalIsOpen: PropTypes.bool.isRequired,
  userTagModalIsOpen: PropTypes.bool.isRequired,
  toggleOrganizationFieldsModalAction: PropTypes.func.isRequired,
  toggleLocaleKeyFieldsModalAction: PropTypes.func.isRequired,
  toggleGroupsFieldsModalAction: PropTypes.func.isRequired,
  toggleUserTagFieldsModalAction: PropTypes.func.isRequired,
  openLocaleKeyFieldsModalAction: PropTypes.func.isRequired,
  openGroupsFieldsModalAction: PropTypes.func.isRequired,
  openOrganizationFieldsModalAction: PropTypes.func.isRequired,
  openUserTagFieldsModalAction: PropTypes.func.isRequired
};

FieldMapping.defaultProps = {
  idpName: ''
};

export default FieldMapping;
